import { useRequestEvent, useRequestHeaders, useRequestURL } from "#imports";
export function useHttpFromRoute(route) {
  const http = {
    params: route.params,
    hash: route.hash,
    query: route.query,
    path: route.path,
    fullPath: route.fullPath,
    // We apply an empty string as default value in order to make this property
    // explicit on Datadog even when no match were found. That way, we'll know
    // that we can filter empty route names when querying our logs.
    routeName: route.name || "",
    // Same here. We apply an empty string as default value in order to make
    // it explicit on Datadog that we can filter empty values. If any route
    // matches on Vue Router side, this will be replaced with the pattern.
    route: "",
    // Again, same pattern here. Those properties will be filled from different
    // sources whether this composable is executed client or server-side.
    method: "",
    protocol: "",
    host: "",
    userAgent: "",
    owners: route.meta?.owners || []
  };
  if (route.matched.length) {
    const matched = route.matched[route.matched.length - 1];
    http.route = matched.path.replace(/\(.*?\)/g, "");
  }
  if (import.meta.client) {
    const url = new URL(window.location.href);
    http.host = url.hostname;
    http.userAgent = navigator.userAgent;
    http.protocol = url.protocol.replace(":", "");
  }
  const event = useRequestEvent();
  if (event) {
    const url = useRequestURL();
    const headers = useRequestHeaders();
    http.method = event.method;
    http.host = url.hostname;
    http.userAgent = headers["user-agent"];
    http.protocol = url.protocol.replace(":", "");
  }
  return http;
}
